import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
//utils
import { getUser } from "utils/auth";

export default function requireAuthentication(WrappedComponent) {
  class AuthenticatedComponent extends Component {
    componentWillMount() {
      this._checkAuth();
    }

    componentWillReceiveProps() {
      this._checkAuth();
    }

    _checkAuth() {
      const { isAuthenticated, redirect, location } = this.props;

      if (!isAuthenticated) {
        return redirect(`/?redirect=${location.pathname}`);
      }
    }

    render() {
      return this.props.isAuthenticated ? (
        <WrappedComponent {...this.props} />
      ) : null;
    }
  }

  AuthenticatedComponent.needs = WrappedComponent.needs;

  return connect(
    state => ({
      isAuthenticated: !!(getUser() && getUser().token && getUser().admin)
    }),
    dispatch => ({
      redirect: bindActionCreators(push, dispatch)
    })
  )(AuthenticatedComponent);
}



// WEBPACK FOOTER //
// ./src/components/authenticated.js